<script setup lang="ts">
import type { RouteLocationRaw } from 'vue-router';

import { RouterLink } from 'vue-router';

export interface Props {
  icon?: string;
  title?: string;
  to?: RouteLocationRaw;
  count?: number;
  loading?: boolean;
  skeletonCount?: number;
}
const props = withDefaults(defineProps<Props>(), {
  icon: 'mdi-history',
  title: '',
  to: undefined,
  count: undefined,
  loading: false,
  skeletonCount: 3,
});
</script>

<template>
  <div
    :class="$style.jobBookingRecentPanel"
    data-testid="jobBookingRecentPanel"
  >
    <div :class="$style.header">
      <component
        :is="props.to ? RouterLink : 'div'"
        :to="props.to"
        :class="$style.headerLeft"
      >
        <div :class="$style.iconWrapper">
          <v-icon :icon="props.icon" size="20" :class="$style.icon" />
        </div>
        <span :class="$style.title">{{ props.title }}</span>
      </component>
      <span v-if="props.count !== undefined" :class="$style.count">{{
        props.count
      }}</span>
    </div>
    <div :class="$style.list">
      <template v-if="props.loading">
        <v-skeleton-loader
          v-for="i in props.skeletonCount"
          :key="i"
          type="list-item-two-line"
        />
      </template>
      <slot v-else />
    </div>
  </div>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';
@use '@/styles/brand-primary' as bp;

.jobBookingRecentPanel {
  border: 1px solid colors.$color-gray-200;
  border-radius: 8px;
  background-color: colors.$color-white;
  overflow: hidden;
}
  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 1rem 1.25rem;
    border-bottom: 1px solid colors.$color-gray-200;
  }
  .headerLeft {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    text-decoration: none;

    &:is(a):hover {
      .title {
        text-decoration: underline;
      }
    }
  }
  .iconWrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    border-radius: 8px;
    background-color: colors.$color-gray-100;
  }
  .icon {
    color: bp.$color-brand-600;
  }
  .title {
    font-size: 1rem;
    font-weight: 600;
    color: colors.$color-text-primary;
  }
  .count {
    font-size: 1rem;
    font-weight: 600;
    color: colors.$color-text-primary;
  }
  .list {
    display: flex;
    flex-direction: column;
  }
</style>
